export default class Spot {

    name
    x
    y
    radius
    color
    stroke
    ball

    constructor(name, x, y, radius, color, stroke) {
        this.name = name
        this.x = Math.round(x)
        this.y = Math.round(y)
        this.radius = Math.round(radius)
        this.color = color
        this.stroke = stroke
    }

    draw(graphics) {
        const circle = new Phaser.Geom.Circle(this.x, this.y, this.radius)
        graphics.lineStyle(this.stroke, this.color, 1)
        graphics.strokeCircleShape(circle)
        graphics.fillStyle(this.color, 0.3)
        graphics.fillCircleShape(circle)
    }
}
